<template>
    <HeaderComponent />
    <SubVisual :src="src" :sitemap="[...this.$route.meta.sitemap, { title: this.$route.meta.name, titleEn: this.$route.meta.nameEn }]" />
    <div class="depth_menu" v-if="this.$route.meta.depth === 1">
        <ul ref="depthMenuList">
            <li v-for="(item, index) in this.$route.meta.parent.subMenus" :key="index">
               <a 
                    v-if="item.key === 'internet_cash_receipt'"
                    :href="item.link.startsWith('http') ? item.link : `https://${item.link}`"
                    target="_blank" 
                    :class="this.$route.fullPath.indexOf(item.link) !== -1 ? 'active' : ''"
                >
                    {{ item[$t('common.name')] }}
                </a>
                <router-link 
                    v-else
                    :to="item.link" 
                    :class="this.$route.fullPath.indexOf(item.link) !== -1 ? 'active' : ''"
                >
                    {{ item[$t('common.name')] }}
                </router-link>
            </li>
        </ul>
    </div>
    <div :class="`subpage_content ${className || ''}`">
        <slot></slot>
    </div>
    <FooterComponent />
</template>
<script>
import FooterComponent from '@/components/FooterComponent.vue';
import HeaderComponent from './HeaderComponent.vue';
import SubVisual from './SubVisual.vue';

export default {
    data() {
        return {};
    },
    mounted() {
        document.title = `${[...this.$route.meta.sitemap].map((el) => el.title).join(' | ')} | ${this.$route.meta[this.$t('common.name')]}`;
        if(document.characterSet === 'EUC-KR') window.location.reload()
        this.$nextTick(() => {
            this.centerActiveDepthMenu();
        });
    },
    watch: {
        '$route.fullPath'() {
            this.$nextTick(() => {
                this.centerActiveDepthMenu();
            });
        },
    },
    methods: {
        centerActiveDepthMenu() {
            const depthMenuList = this.$refs.depthMenuList;

            if (!depthMenuList) {
                return;
            }

            const activeItem = depthMenuList.querySelector('.router-link-active, .active');

            if (!activeItem) {
                return;
            }

            const targetLeft = activeItem.offsetLeft - (depthMenuList.clientWidth - activeItem.clientWidth) / 2;
            const maxScrollLeft = depthMenuList.scrollWidth - depthMenuList.clientWidth;

            depthMenuList.scrollTo({
                left: Math.max(0, Math.min(targetLeft, maxScrollLeft)),
                behavior: 'auto',
            });
        },
    },
    props: {
        src: {},
        sitemap: {},
        className: {},
        parent: {},
    },
    components: {
        HeaderComponent,
        SubVisual,
        FooterComponent,
    },
};
</script>
<style lang="scss" scoped>
.subpage_content {
    padding-bottom: 160px;
}
</style>
